export default {
  path: '/login',
  name: 'Login',
  component: () => import('../views/Login'),
  children: [
    {
      path: '/oidc-code',
      name: 'OIDCCode',
      component: () => import('../views/Login')
    }
  ]
};
